// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2y5hB","addWidgetButton":"Header_addWidgetButton__2T7tM","dashboardTabs":"Header_dashboardTabs__2iNes","active":"Header_active__3YaEk"};